// extracted by mini-css-extract-plugin
export default {"container":"Interest_container__RVxwe","h2":"Interest_h2__qBGdh","button":"Interest_button__LQlcz","disable":"Interest_disable__Sc0Ur","buttonIcon":"Interest_buttonIcon__WtBQl"};